import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function ViewBots (){
  const {user} = useUser()
  let view = contentLayout[modules.BotList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.BotList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.BotList}></Index>
 )
}

export default ViewBots
